var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472,32h-72V0H100.688L0,100.688V496h400V192h72c13.232,0,24-10.768,24-24V56C496,42.768,485.232,32,472,32z M96,27.312 V96H27.312L96,27.312z M384,480H16V112h96V16h272v16H184c-13.232,0-24,10.768-24,24v112c0,13.232,10.768,24,24,24h200V480z  M480,168c0,4.408-3.592,8-8,8H184c-4.408,0-8-3.592-8-8V56c0-4.408,3.592-8,8-8h288c4.408,0,8,3.592,8,8V168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,64h-52v48v8v40h16v-40h36c15.44,0,28-12.56,28-28S259.44,64,244,64z M244,104h-36V80h36c6.616,0,12,5.384,12,12 C256,98.616,250.616,104,244,104z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 128,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 128,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 160,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,64h-32v96h32c26.472,0,48-21.528,48-48S346.472,64,320,64z M320,144h-16V80h16c17.648,0,32,14.352,32,32 S337.648,144,320,144z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384,160 400,160 400,120 448,120 448,104 400,104 400,80 464,80 464,64 384,64  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,247.264v7.272c0,7.776,2.28,15.312,6.592,21.776L190.384,312l-48,72h-55.12C65.616,384,48,401.616,48,423.264v1.472 C48,446.384,65.616,464,87.264,464c13.16,0,25.376-6.536,32.672-17.488L150.952,400h98.104l31.008,46.512 C287.36,457.464,299.576,464,312.736,464C334.384,464,352,446.384,352,424.736v-1.472C352,401.616,334.384,384,312.736,384 h-55.12l-48-72l23.792-35.688c4.312-6.472,6.592-14,6.592-21.776v-7.272C240,225.616,222.384,208,200.736,208h-1.472 C177.616,208,160,225.616,160,247.264z M106.624,437.64c-4.32,6.488-11.56,10.36-19.36,10.36C74.44,448,64,437.56,64,424.736 v-1.472C64,410.44,74.44,400,87.264,400h44.456L106.624,437.64z M312.736,400C325.56,400,336,410.44,336,423.264v1.472 C336,437.56,325.56,448,312.736,448c-7.8,0-15.032-3.872-19.36-10.36L268.28,400H312.736z M238.384,384h-76.776L200,326.424 L238.384,384z M176,247.264C176,234.44,186.44,224,199.264,224h1.472C213.56,224,224,234.44,224,247.264v7.272 c0,4.608-1.352,9.072-3.904,12.904L200,297.576l-20.096-30.144c-2.552-3.824-3.904-8.288-3.904-12.896V247.264z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 416,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 416,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 416,
    width: 16,
    height: 16
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.0d44259c4f8d02864ec0a17258e936d9.svg";
export { ForwardRef as ReactComponent };